import { useState, type InputHTMLAttributes } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Il campo password con l'occhio: mostra e nasconde quello che si sta
 * scrivendo. Serve soprattutto da cellulare, dove un carattere sbagliato non si
 * vede e la password generata da noi è lunga. Il resto lo decide chi lo usa
 * (classi, autocomplete, vincoli), come su un `<input>` qualunque.
 */
export function PasswordInput({ className = "", ...props }: Omit<InputHTMLAttributes<HTMLInputElement>, "type">) {
  const [visibile, setVisibile] = useState(false);
  const Icon = visibile ? EyeOff : Eye;
  return (
    <div className="relative">
      <input {...props} type={visibile ? "text" : "password"} className={`${className} pr-10`} />
      <button
        type="button"
        onClick={() => setVisibile((v) => !v)}
        aria-label={visibile ? "Nascondi password" : "Mostra password"}
        aria-pressed={visibile}
        className="absolute inset-y-0 right-0 flex w-10 items-center justify-center text-muted hover:text-ink"
      >
        <Icon className="h-4 w-4" strokeWidth={1.75} />
      </button>
    </div>
  );
}
